<template>
  <div>
    <ui-modal ref="reporte-pa-modal"
              title="Reporte de planificacion anual"
              size="large"
              @close="closeReportModal()">

      <div>
        <!-- Row 1 -->
        <div class="d-flex">
          <ui-select
            class="w-50 mr-3"
            has-search
            label="Año"
            placeholder="Seleccionar"
            v-model="anioModel"
            :options="yearsFilter"
            :keys="{ value: 'id', label: 'name' }"
          />
          <ui-select
            class="w-50"
            has-search
            label="Cliente"
            placeholder="Seleccionar"
            v-model="clienteModel"
            :keys="{ label: 'name', value: 'id' }"
            :options="clienstFilter"
          />
        </div>
        <!-- Row 2 -->
        <div class="d-flex">
          <ui-select
            class="w-50 mr-3"
            has-search
            label="Contenedor"
            placeholder="Seleccionar"
            v-model="contenedorModel"
            :keys="{ label: 'name', value: 'id' }"
            :options="containersFilter"
          />
          <ui-select
            class="w-50"
            has-search
            label="Producto"
            placeholder="Seleccionar"
            v-model="productoModel"
            :keys="{ label: 'name', value: 'id' }"
            :options="productsFilter"
          />
        </div>
        <!-- Row 3 -->
        <div class="d-flex">
          <ui-select
            class="w-50"
            has-search
            label="Servicio Integral"
            placeholder="Seleccionar"
            v-model="servicioIntegralModel"
            :keys="{ label: 'name', value: 'id' }"
            :options="[{ id: '1', name: 'Sí' },{ id: '0', name: 'No' }]"
          />
        </div>
      </div>
      <div class="d-flex justify-content-between mt-5">
        <div style="float: left;">
          <button class="btn btn-default ml-2" @click="closeReportModal">
            Cerrar
          </button>
          <button class="btn btn-default ml-2" @click="clear">
            Limpiar
          </button>
        </div>
        <div style="float: right;">
          <button class="btn btn-outline-danger ml-2" :disabled="disabledButton" @click="generarReporte()">
            Generar reporte
          </button>
        </div>
      </div>
    </ui-modal>
  </div>
</template>

<script>

import UiModal from "keen-ui/src/UiModal";
import { mapActions, mapState } from "vuex";
import { downloadReportePlanificacionAnual } from "@/constants/lineas";
import uuid from "keen-ui/src/helpers/uuid";

export default {
  components: { UiModal },
  data() {
    return {
      disabledButton: false,
      anioModel: "",
      clienteModel: "",
      contenedorModel: "",
      productoModel: "",
      servicioIntegralModel: ""
    };
  },
  computed: {
    ...mapState("lineas", [
        "paShowReportModal",
        "yearsFilter",
        "clienstFilter",
        "containersFilter",
        "productsFilter"
      ]
    )
  },
  methods: {
    ...mapActions(["ActionSetZindexTablaModal"]),
    ...mapActions("lineas", [
      "actionSetPAShowReportModal"
    ]),
    openModal(ref) {
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },
    clear() {
      this.anioModel = "";
      this.clienteModel = "";
      this.contenedorModel = "";
      this.productoModel = "";
      this.servicioIntegralModel = "";
    },
    closeReportModal() {
      this.ActionSetZindexTablaModal(false);
      this.actionSetPAShowReportModal(false);
      this.closeModal("reporte-pa-modal");
    },
    async generarReporte() {

      this.$vToastify.loader("Exportando reporte planificaciones anuales...");

      this.disabledButton = true;

      await downloadReportePlanificacionAnual({
          year: this.anioModel.id ?? null,
          client_id: this.clienteModel.id ?? null,
          container_id: this.contenedorModel.id ?? null,
          product_id: this.productoModel.id ?? null,
          integral_service: this.servicioIntegralModel.id ?? null
        },
        uuid.short("reporte-planificacion-anual-ucc-")
      );

      this.closeReportModal();

      this.$vToastify.stopLoader();

      this.disabledButton = false;

    }
  },
  watch: {
    paShowReportModal: function(_new) {
      if (_new) {
        this.openModal("reporte-pa-modal");
      }
    },
  }
};
</script>

<style>

</style>